import { EffectHandler } from "../types/editor"

const lianduHandler: EffectHandler = {
    // 添加
    addEffect(editor, selection, value) {
        editor.addcontainEffectHtml({
            range: selection.range,
            effectType: 'liandu',
            effectUIType:'continuous',
            idName: 'continuousId'
        })
    },
    // 修改
    modifyEffect(editor, selection, value) { },
    // 删除
    removeEffect(editor, selection) { },
}
export default lianduHandler